import { Tab } from 'types'

export const DEFAULT_DRIVER_MILES_RATE = 1.5

export const driverPayablesTabs: Tab[] = [
  { id: 'not-paid', label: 'Not Paid' },
  { id: 'paid', label: 'Paid' },
]

export const driverPayablesTableHeaders: Tab[] = [
  { id: 'invoice', label: 'Invoice#' },
  { id: 'week', label: 'Week#' },
  { id: 'rate', label: 'Rate' },
  { id: 'miles', label: 'Miles' },
  { id: 'amount', label: 'Amount' },
  { id: 'documents', label: 'Documents' },
]
